import __ from "web/Layout/Translations";
import { getLanguageCode } from "web/Layout/Translations/LanguageWrapper";

import EmailSenderActivityItem from "web/Components/Common/SubscriptionActivities/ActivityItem/EmailSenderItem/emailSenderItem";
import FileDownloaderActivityItem from "web/Components/Common/SubscriptionActivities/ActivityItem/FileDownloaderItem";
import FormFillerItem from "web/Components/Common/SubscriptionActivities/ActivityItem/FormFillerItem";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import getAttachmentFiles from "web/utils/page/product/subscription/getAttachmentFiles";
import getBenefitAttachments from "web/utils/page/product/subscription/getBenefitAttachments";
import { getIdFromIri } from "web/utils/page/product/subscription/iri";
import setBenefitGroupTypeParam from "web/utils/page/product/subscription/setBenefitGroupTypeParam";

import { NOT_ACTIVE_STATUSES } from "web/constants/benefits";
import restUrls from "web/constants/restUrls";

import {
  ISubscriptionItemCurrentUserSubscription,
  ISubscriptionUserCurrent,
} from "web/types/Subscription";

export default (
  data: ISubscriptionUserCurrent,
  disablePending = true,
  setData: React.Dispatch<React.SetStateAction<ISubscriptionUserCurrent>>
) => {
  const elements = [];
  const benefitsWithFormsToUpdate: ISubscriptionItemCurrentUserSubscription[] =
    [];
  const languageCode = getLanguageCode();
  const {
    id: subscriptionId,
    items: benefits,
    agreementsPdfUrl,
    totals,
  } = data;
  const isAnyBenefitPending = benefits.some((ele) =>
    NOT_ACTIVE_STATUSES.includes(ele.status)
  );
  const showOfflineDeclarations =
    isAnyBenefitPending && agreementsPdfUrl && !disablePending;

  if (isArrayHasItems(benefits)) {
    benefits.forEach((item) => {
      if (!!item.activeForms.length || !!item.forms.length) {
        const { forms, activeForms } = item;
        if (
          forms.some(({ awaitsUpdate }) => awaitsUpdate) ||
          activeForms.some(({ awaitsUpdate }) => awaitsUpdate)
        ) {
          benefitsWithFormsToUpdate.push(item);
        }
      }

      if (!NOT_ACTIVE_STATUSES.includes(item.status)) {
        return;
      }

      const attachments = getBenefitAttachments(item.benefit);

      if (isArrayHasItems(attachments)) {
        attachments.forEach((attachment) => {
          if (attachment.type === "form") {
            const files = getAttachmentFiles(attachment);

            if (isArrayHasItems(files)) {
              files.forEach((file) => {
                if (file.language !== languageCode) return;
                const description = attachment.name;
                const fileUrl = `${restUrls.currentUserSubscription}/attachment/${file.id}`;
                elements.push(
                  <FileDownloaderActivityItem
                    name={item.name}
                    file={fileUrl}
                    description={description}
                  />
                );
              });
            }
          }
        });
      }
      if (isArrayHasItems(item.activeForms)) {
        item.activeForms.forEach((activeForm) => {
          if (!activeForm.completed && activeForm.receiver !== "employee") {
            const benefitUUID = getIdFromIri(
              item["@id"],
              restUrls.employeeSubscriptionItems
            );
            const description = `${__(
              "Nie został wypełniony formularz świadczeń abonamentowych, wysłany na adres e-mail:"
            )} ${activeForm.receiverEmail}`;
            const resendLink = `${
              restUrls.subscriptions
            }/${subscriptionId}/active-form-resend/${getIdFromIri(
              activeForm.formConfig,
              restUrls.activeForms
            )}/${activeForm.receiverEmail}`;

            elements.push(
              <EmailSenderActivityItem
                name={item.name}
                description={description}
                resendLink={resendLink}
                setData={setData}
                activeForm={activeForm}
                benefitUUID={benefitUUID}
              />
            );
          }
        });
      }
      if (isArrayHasItems(item.pdfForms)) {
        item.pdfForms.forEach((pdfForm) => {
          const fileUrl = `${restUrls.subscriptionPdfForm}/${pdfForm.id}`;
          elements.push(
            <FileDownloaderActivityItem
              name={item.name}
              file={fileUrl}
              description={pdfForm.description}
            />
          );
        });
      }
    });
    if (benefitsWithFormsToUpdate.length) {
      const description = __(`
        Uzupełnij swoje dane dotyczące abonamentów, 
        które wybrałeś oraz wpisz adres e-mail osób, 
        dla których wybrałeś abonament.
      `);
      elements.push(
        <FormFillerItem
          benefitsWithFormsToUpdate={benefitsWithFormsToUpdate}
          totals={totals}
          name={__("Zmiana danych w formularzu - wymagane uzupełnienie")}
          description={description}
        />
      );
    }
  }

  if (showOfflineDeclarations) {
    elements.push(
      <FileDownloaderActivityItem
        name={__("Wybrane abonamenty")}
        file={`${
          restUrls.currentUserSubscriptionAgreements
        }${setBenefitGroupTypeParam(data.benefitGroupType)}`}
        description={__("Automatycznie generowane zgody i oświadczenia")}
      />
    );
  }

  return isArrayHasItems(elements) ? elements : [];
};
